import { useQuery } from '@tanstack/react-query';

import { PROJECT_KEY } from './constants';
import { getProject } from './projects';

export const useGetProject = (projectId: number | null | undefined) => {
  return useQuery({
    queryKey: [PROJECT_KEY, projectId],
    queryFn: () => getProject(projectId!),
    enabled: projectId != null,
  });
};
